import firebase from 'firebase/app'
import * as R from 'ramda'

export default {
  client: firebase,
  normalize (objects) {
    return R.pipe(
      R.toPairs,
      R.map((el) => {
        const val = el[1]
        val['.key'] = el[0]
        return val
      })
    )(objects)
  },
  denormalize (arr) {
    return R.pipe(
      R.map((d) => [d['.key'], R.dissoc('.key', d)]),
      R.fromPairs
    )(arr)
  },
  sanitize (data) {
    const dissocKey = R.dissoc('.key')
    return R.is(Array, data)
      ? R.map(dissocKey, data)
      : R.pipe(dissocKey, R.map(dissocKey))(data)
  }
}
